import { useContext } from "react";
import styled from "styled-components";
import WithBackground from "../../core/boilerplate/WithBackground";
import LoggedOutHeader from "../loggedOut/landingPage/LoggedOutHeader";
import Footer from "../loggedOut/landingPage/Footer";
import Context from "../../../Context";

const ScrollWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100%;
  overflow-y: auto;
  gap: 100px;

  @media (max-width: 900px) {
    gap: 30px;
  }
`;

const Content = styled.div`
  width: 62vw;
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    width: 90vw;
  }
`;

const Title = styled.div`
  font-weight: 900;
  font-size: 30px;
  margin-bottom: 30px;
  color: var(--accent);
  width: 90%;
  text-transform: uppercase;
  font-family: "Montserrat", sans-serif;
`;

const Text = styled.div`
  line-height: 1.8;
  font-size: 15px;
  color: var(--element);

  h2 {
    font-size: 22px;
    font-weight: 700;
    margin-top: 35px;
    margin-bottom: 10px;
    color: var(--accent);
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 12px;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 15px;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: var(--accent);
    text-decoration: underline;
  }

  strong {
    font-weight: 600;
  }

  @media (max-width: 900px) {
    font-size: 14px;

    h2 {
      font-size: 19px;
      margin-top: 25px;
    }

    h3 {
      font-size: 16px;
    }
  }
`;

export default function ChildSafety() {
  const { loggedInUserId } = useContext(Context);

  const content = `
    <p><strong>Last updated:</strong> March 15, 2026</p>

    <h2>1. Our Commitment</h2>
    <p>Karuna Social ("Karuna," "we," "our," or "us") is committed to creating a safe environment for all users. We have zero tolerance for child sexual abuse and exploitation (CSAE) of any kind on our platform. We actively work to prevent, detect, and respond to any such content or behavior.</p>

    <h2>2. Prohibited Content and Conduct</h2>
    <p>The following is strictly prohibited on Karuna:</p>
    <ul>
      <li>Any content that depicts, promotes, or glorifies child sexual abuse or exploitation.</li>
      <li>Sharing, distributing, or soliciting child sexual abuse material (CSAM).</li>
      <li>Grooming or any attempt to build a relationship with a minor for the purpose of sexual exploitation.</li>
      <li>Soliciting sexual content or interactions from or involving minors.</li>
      <li>Trafficking or coercing minors in any way.</li>
      <li>Any content that sexualizes minors, including fictional or AI-generated material.</li>
    </ul>

    <h2>3. Age Requirements</h2>
    <p>Karuna is not intended for use by children under the age of 16. We do not knowingly allow users under 16 to create accounts. If we discover that a user is under 16, their account will be immediately suspended and removed.</p>

    <h2>4. Detection and Prevention</h2>
    <p>We employ the following measures to protect children on our platform:</p>
    <ul>
      <li><strong>Content Moderation:</strong> We actively monitor user-generated content to detect and remove prohibited material.</li>
      <li><strong>User Reporting:</strong> All users can report suspected CSAE content or behavior directly within the app.</li>
      <li><strong>Account Enforcement:</strong> Accounts found violating these standards are immediately and permanently banned with no appeal.</li>
      <li><strong>Staff Training:</strong> Our team is trained to identify and handle reports involving child safety.</li>
    </ul>

    <h2>5. Reporting CSAE Content</h2>
    <p>If you encounter any content or behavior on Karuna that exploits or endangers children, please report it immediately:</p>
    <ul>
      <li><strong>In-App:</strong> Use the report feature available on any user profile or content to flag child safety concerns.</li>
      <li><strong>Email:</strong> Contact us at <a href="mailto:safety@karuna.org">safety@karuna.org</a> with details of the concern.</li>
    </ul>
    <p>All reports are reviewed promptly and treated with the highest priority. We will take immediate action to remove content and disable offending accounts.</p>

    <h2>6. Cooperation with Authorities</h2>
    <p>We are committed to cooperating fully with law enforcement and relevant authorities. When we identify or receive a report of CSAE content:</p>
    <ul>
      <li>We immediately remove the content and disable the offending account.</li>
      <li>We preserve relevant evidence for law enforcement.</li>
      <li>We report incidents to the National Center for Missing & Exploited Children (NCMEC) and other applicable regional and national authorities as required by law.</li>
      <li>We comply with all applicable child safety laws and regulations in every jurisdiction where we operate.</li>
    </ul>

    <h2>7. Enforcement Actions</h2>
    <p>Violations of these standards result in immediate action, including but not limited to:</p>
    <ul>
      <li>Immediate removal of the offending content.</li>
      <li>Permanent account suspension with no option for reinstatement.</li>
      <li>Reporting to law enforcement and relevant child protection authorities.</li>
      <li>Preservation of data related to the violation for legal proceedings.</li>
    </ul>

    <h2>8. Contact Us</h2>
    <p>If you have any questions about our child safety standards or wish to report a concern, please contact us:</p>
    <p>Email: <a href="mailto:safety@karuna.org">safety@karuna.org</a></p>
  `;

  return (
    <WithBackground>
      <ScrollWrapper>
        {loggedInUserId ? null : <LoggedOutHeader />}

        <Content>
          <Title>Child Safety Standards</Title>
          <Text dangerouslySetInnerHTML={{ __html: content }} />
          <br />
          <br />
          <br />
          <br />
        </Content>
        <Footer />
      </ScrollWrapper>
    </WithBackground>
  );
}
